<template>
  <div v-if="page" class="page-404">
    <div class="page-404-sky">
      <img class="page-404-cloud page-404-cloud-02" src="/static/404-back-cloud-02.png"/>
      <img class="page-404-lightning" src="/static/404-back-lightning.png"/>
      <img class="page-404-animation page-404-animation-03" src="/static/404-parachute-03.png"/>
      <img class="page-404-cloud page-404-cloud-03" src="/static/404-back-cloud-03.png"/>
      <img class="page-404-cloud page-404-cloud-01" src="/static/404-back-cloud-01.png"/>
    </div>
    <div class="page-404-back">
      
      <img class="page-404-animation page-404-animation-02" src="/static/404-parachute-02.png"/>
      <img class="page-404-animation page-404-animation-01" src="/static/404-parachute-01.png"/>
    </div>
    <div class="page">
      <div class="page-404-wrap">
        <h1 class="cursive">404</h1>
        <h2>{{ text[lang].title }}</h2>
        <div v-html="text[lang].desc"/>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';


export default {
  computed: mapGetters({
    page: 'page',
    lang: 'lang',
  }),

  metaInfo() {
    return {
      title: this.title,
    };
  },

  mounted() {
    this.title = this.text[this.lang].header;
  },

  data() {
    return {
      title: '404',
      text: [
        {
          header: 'Ошибка 404: страница не найдена',
          title: 'Страница не найдена',
          desc: '<p>Неправильно набран адрес, или такой страницы на&nbsp;сайте больше не&nbsp;существует.</p><p>Вернитесь на <a href="/">главную страницу</a>.</p>',
        },
        {
          header: 'Error 404: page not found',
          title: 'Page not found',
          desc: '<p>You have misspelled the URL, or this page does not exist any more.</p><p>Return to the <a href="/">homepage</a>.</p>',
        },
      ],
    };
  },

};
</script>


<style>

@keyframes parachutes{
  from {
    transform: rotateZ(-10deg);
  }
  50%{
    transform: rotateZ(10deg);
  }
  to {
    transform: rotateZ(-10deg);
  }
}

@keyframes light{
  from {
    opacity: 0;
  }
  5%{
    opacity: 0;
  }
  6%{
    opacity: 1;
  }
  8%{
    opacity: 0;
  }
  10%,
  15%{
    opacity: 1;
  }
  18%{
    opacity: 0;
  }
  34%{
    opacity: 0;
  }
  35%{
    opacity: 0;
  }
  36%{
    opacity: 1;
  }
  42%{
    opacity: 0;
  }
  44%{
    opacity: 1;
  }
  50%{
    opacity: 0;
  }
  79%{
    opacity: 0;
  }
  80%{
    opacity: 1
  }
  85%{
    opacity: 0;
  }
  to {
    opacity: 0;
  }
}

@keyframes sky { 
    0%{background-position:50% 0%}
    50%{background-position:51% 100%}
    100%{background-position:50% 0%}
}

@keyframes cloud { 
    from {
      transform: translate3d(0,80vh,0);
      opacity: 0;
    }
    10%{
      opacity: 1;
    }
    90%{
      opacity: 1;
    }
    to {
      transform: translate3d(0,-100vh,0);
      opacity: 0;
    }
}

.page-404{
  position: absolute;
  min-height: 100%;
  color: white;
  width: 100%;
  left: 0;
  top: 0;

  &-sky,
  &-back{
    /*background: url(/static/404-back.png);*/
    background-size: cover;
    position: absolute;
    overflow: hidden;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
  }

  &-lightning{
    animation: light 8s infinite;
    animation-timing-function: ease-in-out;
    height: 100vh;
  }

  &-lightning,
  &-cloud{
    position: absolute;
    left: 0;
  }

  &-cloud{
    animation: cloud 50s ease infinite;
    animation-timing-function: ease-in-out;
    &-01{
      animation-duration: 40s;
      width: 50vw;
      top: 75vh;
      left: 50vw;
    }
    &-02{
      width: 100vw;
      top: 57vh;
      left: 3vw;
    }
    &-03{
      animation-duration: 30s;
      width: 50vw;
      top: 5vh;
      left: 23vw;
    }
  }

  &-sky{
    background: linear-gradient(0, #020f34, #091b35);
    background-size: 400% 400%;
  }

  &-wrap{
    margin-top: 15vh;
    @media (max-width: $mediaMini) {
      padding-right: 5vw;
      padding-left: 5vw;
    }
  }

  &-animation{
    animation: parachutes 5s infinite;
    animation-timing-function: ease-in-out;
    transform-origin: top center;
    position: absolute;

    &-01 {
      max-width: 400px;
      width: 30vw;
      left: 56vw;
      top: 25%;
    }

    &-02 {
      animation-duration: 8s;
      max-width: 350px;
      width: 22vw;
      left: 5vw;
      top: 40%;
    }

    &-03 {
      animation-duration: 12s;
      max-width: 300px;
      width: 18vw;
      left: 25vw;
      top: 5%;
    }
  }

  h1{
    font-family: 'Mirta', sans-serif;
    margin-bottom: -2vw;
    padding-bottom: 0;
    font-weight: 400;
    font-size: 22vw;

    @media (min-width: 1700px) {
      font-size: 3000%;
    }
  }

  h2{
    font-family: 'Direct', sans-serif;
    font-weight: 400;
    margin-top: 0px;
    font-size: 4vw;

    @media (min-width: 1700px) {
      font-size: 400%;
    }
  }

  p{
    font-family: 'Mirta', sans-serif;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/404.vue